var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-data-item"},[_c('p',{staticClass:"card-data-item-title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('p',{staticClass:"card-data-item-value"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }